export default __webpack_public_path__ + "static/media/the-thing.cd52efa9.jpg";